import { useQuery } from "@tanstack/react-query"
import {
  ClearCardReaderReq,
  ClearCardReaderRes,
  CreateAdditionalFeeReq,
  CreateAdditionalFeeRes,
  CreateCustomTaxRateReq,
  CreateCustomTaxRateRes,
  CreateFinanceChargeSettingReq,
  CreateFinanceChargeSettingRes,
  CreateFinancingTermReq,
  CreateFinancingTermRes,
  CreateLocationReq,
  CreateLocationRes,
  CreatePricingTierReq,
  CreatePricingTierRes,
  BulkUpsertDepartmentsReq,
  BulkUpsertDepartmentsRes,
  BulkUpsertClassesReq,
  BulkUpsertClassesRes,
  BulkUpsertFinelineReq,
  BulkUpsertFinelineRes,
  CreateCardSetupIntentForEntityReq,
  CreateCardSetupIntentForEntityRes,
  CreateProductCategoryV2Req,
  CreateProductCategoryV2Res,
  CreateSaleFormReq,
  CreateSaleFormRes,
  CreateStaffReq,
  CreateStaffRes,
  CreateCustomTenderMethodReq,
  CreateCustomTenderMethodRes,
  UpdateCustomTenderMethodReq,
  UpdateCustomTenderMethodRes,
  UpdateDefaultTenderMethodUsagesReq,
  UpdateDefaultTenderMethodUsagesRes,
  DeactivateCustomTaxRateReq,
  DeactivateCustomTaxRateRes,
  DeactivateFinanceChargeSettingReq,
  DeactivateFinanceChargeSettingRes,
  DeactivateProductCategoryV2Req,
  DeactivateProductCategoryV2Res,
  DeactivateStaffReq,
  DeactivateStaffRes,
  DeactivateStaffWebAuthnKeysReq,
  DeactivateStaffWebAuthnKeysRes,
  DeleteAdditionalFeeReq,
  DeleteAdditionalFeeRes,
  DeleteFinancingTermReq,
  DeleteFinancingTermRes,
  DeletePricingTierReq,
  DeletePricingTierRes,
  DeleteSaleFormReq,
  DeleteSaleFormRes,
  GetCompanyForSubdomainRes,
  GetCompanyReq,
  GetCompanyRes,
  GetCurrentUserReq,
  GetCurrentUserRes,
  GetAgreementPDFForCompanyReq,
  GetAgreementPDFForCompanyRes,
  GetEntityBillingInfoReq,
  GetEntityBillingInfoRes,
  GetNeedsBillingPaymentMethodReq,
  GetNeedsBillingPaymentMethodRes,
  GetLocationReq,
  GetLocationRes,
  GetProductCategoryTreeReq,
  GetProductCategoryTreeRes,
  GetOrCreateCustomTaxRateForAddressReq,
  GetOrCreateCustomTaxRateForAddressRes,
  GetPermissionsGroupsReq,
  GetPermissionsGroupsRes,
  GetStaffReq,
  GetStaffRes,
  GetStripeAccountSessionReq,
  GetStripeAccountSessionRes,
  GetIsStripePaymentsReadyReq,
  GetIsStripePaymentsReadyRes,
  GetStripeLoginURLReq,
  GetStripeLoginURLRes,
  GetStripeOnboardingURLReq,
  GetStripeOnboardingURLRes,
  ListActiveFinanceChargeSettingsForCompanyReq,
  ListActiveFinanceChargeSettingsForCompanyRes,
  ListActiveLoyaltyRewardsForCompanyReq,
  ListActiveLoyaltyRewardsForCompanyRes,
  ListAdditionalFeesForCompanyReq,
  ListAdditionalFeesForCompanyRes,
  ListAgreementsForCompanyReq,
  ListAgreementsForCompanyRes,
  ListAuthorizedEndpointsReq,
  ListAuthorizedEndpointsRes,
  ListCardReadersForLocationReq,
  ListCardReadersForLocationRes,
  ListCustomersForFinanceChargeSettingReq,
  ListCustomersForFinanceChargeSettingRes,
  ListCustomersForTermReq,
  ListCustomersForTermRes,
  ListCustomersForTierReq,
  ListCustomersForTierRes,
  ListEntitiesForCompanyReq as ListEntitiesReq,
  ListEntitiesForCompanyRes as ListEntitiesRes,
  ListFinancingTermsForCompanyReq,
  ListFinancingTermsForCompanyRes,
  ListLocationsForCompanyReq,
  ListLocationsForCompanyRes,
  ListPricingTiersForCompanyReq,
  ListPricingTiersForCompanyRes,
  ListProductCategoriesForCompanyV2Req,
  ListProductCategoriesForCompanyV2Res,
  ListProductsForCategoryV2Req,
  ListProductsForCategoryV2Res,
  ListProductsForFeeReq,
  ListProductsForFeeRes,
  ListStatesAndProvincesReq,
  ListStatesAndProvincesRes,
  ListSaleFormsReq,
  ListSaleFormsRes,
  ListStaffsForCompanyReq,
  ListStaffsForCompanyRes,
  ListTaxRatesForCompanyReq,
  ListTaxRatesForCompanyRes,
  ReactivateStaffReq,
  ReactivateStaffRes,
  ReorderAdditionalFeesReq,
  ReorderAdditionalFeesRes,
  ReorderCustomTaxRatesReq,
  ReorderCustomTaxRatesRes,
  ReorderFinanceChargeSettingsReq,
  ReorderFinanceChargeSettingsRes,
  ReorderFinancingTermsReq,
  ReorderFinancingTermsRes,
  ReorderPricingTiersReq,
  ReorderPricingTiersRes,
  SetEntityDefaultPaymentMethodReq,
  SetEntityDefaultPaymentMethodRes,
  UpdateAdditionalFeeReq,
  UpdateAdditionalFeeRes,
  UpdateCardSurchargeRateReq,
  UpdateCardSurchargeRateRes,
  UpdateCompanyContractorRewardsSettingsReq,
  UpdateCompanyContractorRewardsSettingsRes,
  UpdateCompanyDefaultDepositRateReq,
  UpdateCompanyDefaultDepositRateRes,
  UpdateCompanyGeneralCommunicationsSettingsReq,
  UpdateCompanyGeneralCommunicationsSettingsRes,
  UpdateCompanyGeneralSettingsReq,
  UpdateCompanyGeneralSettingsRes,
  UpdateCompanyIsCardSurchargeTaxExemptReq,
  UpdateCompanyIsCardSurchargeTaxExemptRes,
  UpdateCompanyIsCartReaderSyncDisabledReq,
  UpdateCompanyIsCartReaderSyncDisabledRes,
  UpdateCompanyIsColorFormulaHiddenReq,
  UpdateCompanyIsColorFormulaHiddenRes,
  UpdateCompanyIsDesignatedClerkEnabledReq,
  UpdateCompanyIsDesignatedClerkEnabledRes,
  UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq,
  UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes,
  UpdateCompanyShouldHideCategoryBrowserReq,
  UpdateCompanyShouldHideCategoryBrowserRes,
  ListUnitsOfMeasureForCompanyReq,
  ListUnitsOfMeasureForCompanyRes,
  AddCompanyUnitOfMeasureReq,
  AddCompanyUnitOfMeasureRes,
  BulkUpsertUnitsOfMeasureReq,
  BulkUpsertUnitsOfMeasureRes,
  UpdateCompanyUnitOfMeasureReq,
  UpdateCompanyUnitOfMeasureRes,
  DeleteCompanyUnitOfMeasureReq,
  DeleteCompanyUnitOfMeasureRes,
  UpdateCompanyIsDiscountShownToCustomersReq,
  UpdateCompanyIsDiscountShownToCustomersRes,
  UpdateCompanyLoyaltyOptionsReq,
  UpdateCompanyLoyaltyOptionsRes,
  UpdateCompanyLoyaltyRewardReq,
  UpdateCompanyLoyaltyRewardRes,
  UpdateCompanyIsFinancingTermsShownOnInvoiceReq,
  UpdateCompanyIsFinancingTermsShownOnInvoiceRes,
  UpdateCompanyEcommerceSettingsReq,
  UpdateCompanyEcommerceSettingsRes,
  UpdateCompanyIsLoyaltyProgramEnabledReq,
  UpdateCompanyIsLoyaltyProgramEnabledRes,
  UpdateCompanyIsPriceShownOnWillCallReq,
  UpdateCompanyIsPriceShownOnWillCallRes,
  UpdateCompanyShouldShowCostsOnTransferPrintsReq,
  UpdateCompanyShouldShowCostsOnTransferPrintsRes,
  UpdateCompanyLoyaltyProgramPolicyReq,
  UpdateCompanyLoyaltyProgramPolicyRes,
  UpdateCompanyPreserveSaleProductPriceEditsReq,
  UpdateCompanyPreserveSaleProductPriceEditsRes,
  UpdateCompanySecuritySettingsReq,
  UpdateCompanySecuritySettingsRes,
  UpdateCompanyShouldAutoApplyReturnCreditsReq,
  UpdateCompanyShouldAutoApplyReturnCreditsRes,
  UpdateCompanyShouldHideReturnConfirmationReq,
  UpdateCompanyShouldHideReturnConfirmationRes,
  UpdateCompanyShouldAllowNonStockCostEditsReq,
  UpdateCompanyShouldAllowNonStockCostEditsRes,
  UpdateCompanyShouldAllowNonStockPriceCostEditsReq,
  UpdateCompanyShouldAllowNonStockPriceCostEditsRes,
  UpdateCompanyShouldAllowReturnsWithoutNoteReq,
  UpdateCompanyShouldAllowReturnsWithoutNoteRes,
  UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq,
  UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes,
  UpdateCompanyIsBmDataSharingEnabledReq,
  UpdateCompanyIsBmDataSharingEnabledRes,
  UpdateCompanyShouldAutoSubmitContractorRewardsReq,
  UpdateCompanyShouldAutoSubmitContractorRewardsRes,
  UpdateCompanyTaxRateModeReq,
  UpdateCompanyTaxRateModeRes,
  UpdateCompanyShouldSetOrderedProductQuantityToZeroReq,
  UpdateCompanyShouldSetOrderedProductQuantityToZeroRes,
  UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq,
  UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes,
  UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq,
  UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes,
  UpdateCompanyProductImageSettingsReq,
  UpdateCompanyProductImageSettingsRes,
  UpdateCompanyShouldShowAccountBalanceOnReceiptReq,
  UpdateCompanyShouldShowAccountBalanceOnReceiptRes,
  UpdateCompanyShouldSkipLinkingReturnsReq,
  UpdateCompanyShouldSkipLinkingReturnsRes,
  UpdateCompanyDefaultReceiptQuantityReq,
  UpdateCompanyDefaultReceiptQuantityRes,
  UpdateCompanyQuickPrintSettingsReq,
  UpdateCompanyQuickPrintSettingsRes,
  UpdateCompanyQuickPrintPrinterByLocationReq,
  UpdateCompanyQuickPrintPrinterByLocationRes,
  UpdateCompanyStatementSettingsReq,
  UpdateCompanyStatementSettingsRes,
  UpdateCostManagementSettingsReq,
  UpdateCostManagementSettingsRes,
  UpdateCustomTaxRateReq,
  UpdateCustomTaxRateRes,
  UpdateFinanceChargeSettingReq,
  UpdateFinanceChargeSettingRes,
  UpdateFinancingTermReq,
  UpdateFinancingTermRes,
  UpdateLocationBMOutletNumberReq,
  UpdateLocationBMOutletNumberRes,
  UpdateLocationCashDrawersReq,
  UpdateLocationCashDrawersRes,
  UpdateLocationGoogleReviewUrlReq,
  UpdateLocationGoogleReviewUrlRes,
  UpdateLocationIsActiveReq,
  UpdateLocationIsActiveRes,
  UpdateLocationLogoImageUrlReq,
  UpdateLocationLogoImageUrlRes,
  UpdateLocationQuickbooksClassReq,
  UpdateLocationQuickbooksClassRes,
  UpdateLocationReq,
  UpdateLocationRes,
  UpdateLocationStatementMessageReq,
  UpdateLocationStatementMessageRes,
  UpdatePricingTierReq,
  UpdatePricingTierRes,
  UpdateProductCategoryV2Req,
  UpdateProductCategoryV2Res,
  UpdateSaleFormReq,
  UpdateSaleFormRes,
  BulkUpsertStaffReq,
  BulkUpsertStaffRes,
  UpdateStaffPermissionsReq,
  UpdateStaffPermissionsRes,
  UpdateStaffReq,
  UpdateStaffRes,
  UpdateStaffIsAttributionEnabledReq,
  UpdateStaffIsAttributionEnabledRes,
  UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq,
  UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes,
  UpdateCompanyShouldRequireVoidReasonReq,
  UpdateCompanyShouldRequireVoidReasonRes,
  ListDrawerMethodsReq,
  ListDrawerMethodsRes,
  DeactivateCustomTenderMethodReq,
  DeactivateCustomTenderMethodRes,
  ActivateCustomTenderMethodReq,
  ActivateCustomTenderMethodRes,
  UpdateCompanyShouldShowInventoryNegativeWarningRes,
  UpdateCompanyShouldShowInventoryNegativeWarningReq,
  UpdateCompanyShouldWarnWhenSellingBelowCostReq,
  UpdateCompanyShouldWarnWhenSellingBelowCostRes,
  UpdateCompanyIsDiscountPercentageShownOnReceiptReq,
  UpdateCompanyIsDiscountPercentageShownOnReceiptRes,
  UpdateCompanyAllowDifferentFulfillmentLocationReq,
  UpdateCompanyAllowDifferentFulfillmentLocationRes,
  ReorderTenderMethodsReq,
  ReorderTenderMethodsRes,
  UpdateCompanyShouldAutoApplyCreditsOnStatementsReq,
  UpdateCompanyShouldAutoApplyCreditsOnStatementsRes,
  UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq,
  UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes,
  UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq,
  UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes,
  UpdateCompanyShouldRequireCustomerOnSaleReq,
  UpdateCompanyShouldRequireCustomerOnSaleRes,
  UpdateCompanyCustomEmailConfigReq,
  UpdateCompanyCustomEmailConfigRes,
  ValidateCompanyCustomEmailConfigReq,
  ValidateCompanyCustomEmailConfigRes,
  GetIsGiftCardsEnabledReq,
  GetIsGiftCardsEnabledRes,
  UpdateCompanyStartInventoryCountsAtOnHandReq,
  UpdateCompanyStartInventoryCountsAtOnHandRes,
  GetCurrentUserIsAttributionEnabledReq,
  GetCurrentUserIsAttributionEnabledRes,
  ValidateStaffAttributionPinReq,
  ValidateStaffAttributionPinRes,
  ClearStaffAttributionPinReq,
  ClearStaffAttributionPinRes,
  GetIsBankingPermittedRes,
  GetIsBankingPermittedReq,
  ListTaxRatesForLocationReq,
  ListTaxRatesForLocationRes,
  CreatePricingRegionReq,
  CreatePricingRegionRes,
  DeactivatePricingRegionReq,
  DeactivatePricingRegionRes,
  ListPricingRegionsForCompanyReq,
  ListPricingRegionsForCompanyRes,
  ReorderPricingRegionsReq,
  ReorderPricingRegionsRes,
  UpdateCompanyIsPricingByRegionEnabledReq,
  UpdateCompanyIsPricingByRegionEnabledRes,
  UpdateLocationPricingRegionReq,
  UpdateLocationPricingRegionRes,
  UpdateLocationCashRoundingReq,
  UpdateLocationCashRoundingRes,
  UpdatePricingRegionNameReq,
  UpdatePricingRegionNameRes,
  UpdateLocationShowInventoryReq,
  UpdateLocationShowInventoryRes,
} from "gen/api/company/service_pb"
import { CompanyServiceClient } from "gen/api/company/service_pb.client"
import {
  Company,
  Company_PrinterSettings as PrinterSettings,
  Company_PrinterSettings_LocationSettings as PrinterLocationSettings,
} from "gen/company/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { UUID } from "shared-ts/classes/uuid"

import { apiSlice, transport } from "./apiSlice"

const c = new CompanyServiceClient(transport)

export const companyApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: [
      "Company",
      "TenderMethod",
      "Location",
      "Staff",
      "PricingTier",
      "FinancingTerm",
      "FinancingRate",
      "ProductCategory",
      "ProductCategoryV2",
      "ProductCategoryTree",
      "AdditionalFee",
      "TaxRate",
      "PermissionsGroups",
      "FinanceChargeSetting",
      "SaleForm",
      "Entity",
      "UnitOfMeasure",
      "CurrentUser",
      "PricingRegion",
      "EntityBilling",
      "LoyaltyReward",
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      listStatesAndProvinces: builder.query<
        ListStatesAndProvincesRes,
        ListStatesAndProvincesReq
      >({
        query: (r) => c.listStatesAndProvinces(r),
      }),
      /* Company */
      getCompanyForSubdomain: builder.query<GetCompanyForSubdomainRes, string>({
        query: (subdomain) => c.getCompanyForSubdomain({ subdomain }),
      }),
      getCompany: builder.query<GetCompanyRes, GetCompanyReq>({
        query: (r) => c.getCompany(r),
        providesTags: ["Company"],
      }),
      updateCompanyGeneralSettings: builder.mutation<
        UpdateCompanyGeneralSettingsRes,
        UpdateCompanyGeneralSettingsReq
      >({
        query: (r) => c.updateCompanyGeneralSettings(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanySecuritySettings: builder.mutation<
        UpdateCompanySecuritySettingsRes,
        UpdateCompanySecuritySettingsReq
      >({
        query: (r) => c.updateCompanySecuritySettings(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyShouldAutoSubmitContractorRewards: builder.mutation<
        UpdateCompanyShouldAutoSubmitContractorRewardsRes,
        UpdateCompanyShouldAutoSubmitContractorRewardsReq
      >({
        query: (r) => c.updateCompanyShouldAutoSubmitContractorRewards(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldAutoSubmitContractorRewards =
                req.shouldAutoSubmitContractorRewards
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyIsBmDataSharingEnabled: builder.mutation<
        UpdateCompanyIsBmDataSharingEnabledRes,
        UpdateCompanyIsBmDataSharingEnabledReq
      >({
        query: (r) => c.updateCompanyIsBmDataSharingEnabled(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isBmDataSharingEnabled = req.isBmDataSharingEnabled
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyContractorRewardsSettings: builder.mutation<
        UpdateCompanyContractorRewardsSettingsRes,
        UpdateCompanyContractorRewardsSettingsReq
      >({
        query: (r) => c.updateCompanyContractorRewardsSettings(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyIsDiscountShownToCustomers: builder.mutation<
        UpdateCompanyIsDiscountShownToCustomersRes,
        UpdateCompanyIsDiscountShownToCustomersReq
      >({
        query: (r) => c.updateCompanyIsDiscountShownToCustomers(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isDiscountShownToCustomers = req.isDiscountShownToCustomers
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyLoyaltyOptions: builder.mutation<
        UpdateCompanyLoyaltyOptionsRes,
        UpdateCompanyLoyaltyOptionsReq
      >({
        query: (r) => c.updateCompanyLoyaltyOptions(r),
        invalidatesTags: ["Company", "LoyaltyReward"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.loyaltyOptions = req.loyaltyOptions
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      listActiveLoyaltyRewardsForCompany: builder.query<
        ListActiveLoyaltyRewardsForCompanyRes,
        ListActiveLoyaltyRewardsForCompanyReq
      >({
        query: (r) => c.listActiveLoyaltyRewardsForCompany(r),
        providesTags: ["LoyaltyReward"],
      }),
      updateCompanyLoyaltyReward: builder.mutation<
        UpdateCompanyLoyaltyRewardRes,
        UpdateCompanyLoyaltyRewardReq
      >({
        query: (r) => c.updateCompanyLoyaltyReward(r),
        invalidatesTags: ["LoyaltyReward"],
      }),
      updateCompanyIsDiscountPercentageShownOnReceipt: builder.mutation<
        UpdateCompanyIsDiscountPercentageShownOnReceiptRes,
        UpdateCompanyIsDiscountPercentageShownOnReceiptReq
      >({
        query: (r) => c.updateCompanyIsDiscountPercentageShownOnReceipt(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isDiscountPercentageShownOnReceipt =
                req.isDiscountPercentageShownOnReceipt
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldShowInventoryNegativeWarning: builder.mutation<
        UpdateCompanyShouldShowInventoryNegativeWarningRes,
        UpdateCompanyShouldShowInventoryNegativeWarningReq
      >({
        query: (r) => c.updateCompanyShouldShowInventoryNegativeWarning(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldShowInventoryNegativeWarning =
                req.shouldShowInventoryNegativeWarning
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldWarnWhenSellingBelowCost: builder.mutation<
        UpdateCompanyShouldWarnWhenSellingBelowCostRes,
        UpdateCompanyShouldWarnWhenSellingBelowCostReq
      >({
        query: (r) => c.updateCompanyShouldWarnWhenSellingBelowCost(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldWarnWhenSellingBelowCost =
                req.shouldWarnWhenSellingBelowCost
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyIsColorFormulaHidden: builder.mutation<
        UpdateCompanyIsColorFormulaHiddenRes,
        UpdateCompanyIsColorFormulaHiddenReq
      >({
        query: (r) => c.updateCompanyIsColorFormulaHidden(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isColorFormulaHidden = req.isColorFormulaHidden
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyIsDesignatedClerkEnabled: builder.mutation<
        UpdateCompanyIsDesignatedClerkEnabledRes,
        UpdateCompanyIsDesignatedClerkEnabledReq
      >({
        query: (r) => c.updateCompanyIsDesignatedClerkEnabled(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isDesignatedClerkEnabled = req.isDesignatedClerkEnabled
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyIsDepositsAndPartialFulfillmentEnabled: builder.mutation<
        UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes,
        UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq
      >({
        query: (r) => c.updateCompanyIsDepositsAndPartialFulfillmentEnabled(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isDepositsAndPartialFulfillmentEnabled =
                req.isDepositsAndPartialFulfillmentEnabled
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldHideCategoryBrowser: builder.mutation<
        UpdateCompanyShouldHideCategoryBrowserRes,
        UpdateCompanyShouldHideCategoryBrowserReq
      >({
        query: (r) => c.updateCompanyShouldHideCategoryBrowser(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldHideCategoryBrowser = req.shouldHideCategoryBrowser
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyIsFinancingTermsShownOnInvoice: builder.mutation<
        UpdateCompanyIsFinancingTermsShownOnInvoiceRes,
        UpdateCompanyIsFinancingTermsShownOnInvoiceReq
      >({
        query: (r) => c.updateCompanyIsFinancingTermsShownOnInvoice(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isFinancingTermsShownOnInvoice =
                req.isFinancingTermsShownOnInvoice
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyIsPriceShownOnWillCall: builder.mutation<
        UpdateCompanyIsPriceShownOnWillCallRes,
        UpdateCompanyIsPriceShownOnWillCallReq
      >({
        query: (r) => c.updateCompanyIsPriceShownOnWillCall(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isPriceShownOnWillCall = req.isPriceShownOnWillCall
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldShowCostsOnTransferPrints: builder.mutation<
        UpdateCompanyShouldShowCostsOnTransferPrintsRes,
        UpdateCompanyShouldShowCostsOnTransferPrintsReq
      >({
        query: (r) => c.updateCompanyShouldShowCostsOnTransferPrints(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldShowCostsOnTransferPrints =
                req.shouldShowCostsOnTransferPrints
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyIsCartReaderSyncDisabled: builder.mutation<
        UpdateCompanyIsCartReaderSyncDisabledRes,
        UpdateCompanyIsCartReaderSyncDisabledReq
      >({
        query: (r) => c.updateCompanyIsCartReaderSyncDisabled(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isCartReaderSyncDisabled = req.isCartReaderSyncDisabled
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyTaxRateMode: builder.mutation<
        UpdateCompanyTaxRateModeRes,
        UpdateCompanyTaxRateModeReq
      >({
        query: (r) => c.updateCompanyTaxRateMode(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.taxRateMode = req.taxRateMode
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyGeneralCommunicationsSettings: builder.mutation<
        UpdateCompanyGeneralCommunicationsSettingsRes,
        UpdateCompanyGeneralCommunicationsSettingsReq
      >({
        query: (r) => c.updateCompanyGeneralCommunicationsSettings(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyStatementSettings: builder.mutation<
        UpdateCompanyStatementSettingsRes,
        UpdateCompanyStatementSettingsReq
      >({
        query: (r) => c.updateCompanyStatementSettings(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyIsCardSurchargeTaxExempt: builder.mutation<
        UpdateCompanyIsCardSurchargeTaxExemptRes,
        UpdateCompanyIsCardSurchargeTaxExemptReq
      >({
        query: (r) => c.updateCompanyIsCardSurchargeTaxExempt(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyIsLoyaltyProgramEnabled: builder.mutation<
        UpdateCompanyIsLoyaltyProgramEnabledRes,
        UpdateCompanyIsLoyaltyProgramEnabledReq
      >({
        query: (r) => c.updateCompanyIsLoyaltyProgramEnabled(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isLoyaltyProgramEnabled = req.isLoyaltyProgramEnabled
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyEcommerceSettings: builder.mutation<
        UpdateCompanyEcommerceSettingsRes,
        UpdateCompanyEcommerceSettingsReq
      >({
        query: (r) => c.updateCompanyEcommerceSettings(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.ecommerceSettings = req.ecommerceSettings
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyLoyaltyProgramPolicy: builder.mutation<
        UpdateCompanyLoyaltyProgramPolicyRes,
        UpdateCompanyLoyaltyProgramPolicyReq
      >({
        query: (r) => c.updateCompanyLoyaltyProgramPolicy(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyShouldAutoApplyReturnCredits: builder.mutation<
        UpdateCompanyShouldAutoApplyReturnCreditsRes,
        UpdateCompanyShouldAutoApplyReturnCreditsReq
      >({
        query: (r) => c.updateCompanyShouldAutoApplyReturnCredits(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldAutoApplyReturnCredits =
                request.shouldAutoApplyReturnCredits
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldHideReturnConfirmation: builder.mutation<
        UpdateCompanyShouldHideReturnConfirmationRes,
        UpdateCompanyShouldHideReturnConfirmationReq
      >({
        query: (r) => c.updateCompanyShouldHideReturnConfirmation(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldHideReturnConfirmation =
                request.shouldHideReturnConfirmation
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldAllowReturnsWithoutNote: builder.mutation<
        UpdateCompanyShouldAllowReturnsWithoutNoteRes,
        UpdateCompanyShouldAllowReturnsWithoutNoteReq
      >({
        query: (r) => c.updateCompanyShouldAllowReturnsWithoutNote(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldAllowReturnsWithoutNote =
                request.shouldAllowReturnsWithoutNote
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldAllowNonStockPriceCostEdits: builder.mutation<
        UpdateCompanyShouldAllowNonStockPriceCostEditsRes,
        UpdateCompanyShouldAllowNonStockPriceCostEditsReq
      >({
        query: (r) => c.updateCompanyShouldAllowNonStockPriceCostEdits(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldAllowNonStockPriceCostEdits =
                request.shouldAllowNonStockPriceCostEdits
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldAllowNonStockCostEdits: builder.mutation<
        UpdateCompanyShouldAllowNonStockCostEditsRes,
        UpdateCompanyShouldAllowNonStockCostEditsReq
      >({
        query: (r) => c.updateCompanyShouldAllowNonStockCostEdits(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldAllowNonStockCostEdits =
                request.shouldAllowNonStockCostEdits
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldAutoSignOutAfterSaleSettings: builder.mutation<
        UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes,
        UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq
      >({
        query: (r) => c.updateCompanyShouldAutoSignOutAfterSaleSettings(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldAutoSignOutAfterSale = req.shouldAutoSignOutAfterSale
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldSetOrderedProductQuantityToZero: builder.mutation<
        UpdateCompanyShouldSetOrderedProductQuantityToZeroRes,
        UpdateCompanyShouldSetOrderedProductQuantityToZeroReq
      >({
        query: (r) => c.updateCompanyShouldSetOrderedProductQuantityToZero(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldSetOrderedProductQuantityToZero =
                req.shouldSetOrderedProductQuantityToZero
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldTriggerOrderWhenStockBelowMin: builder.mutation<
        UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes,
        UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq
      >({
        query: (r) => c.updateCompanyShouldTriggerOrderWhenStockBelowMin(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldTriggerOrderWhenStockBelowMin =
                req.shouldTriggerOrderWhenStockBelowMin
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldMatchStandardAndDefaultToOneTimeCost: builder.mutation<
        UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes,
        UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq
      >({
        query: (r) =>
          c.updateCompanyShouldMatchStandardAndDefaultToOneTimeCost(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldMatchStandardAndDefaultToOneTimeCost =
                req.shouldMatchStandardAndDefaultToOneTimeCost
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyProductImageSettings: builder.mutation<
        UpdateCompanyProductImageSettingsRes,
        UpdateCompanyProductImageSettingsReq
      >({
        query: (r) => c.updateCompanyProductImageSettings(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldHideAllProductImages = req.shouldHideAllProductImages
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldShowAccountBalanceOnReceipt: builder.mutation<
        UpdateCompanyShouldShowAccountBalanceOnReceiptRes,
        UpdateCompanyShouldShowAccountBalanceOnReceiptReq
      >({
        query: (r) => c.updateCompanyShouldShowAccountBalanceOnReceipt(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldShowAccountBalanceOnReceipt =
                req.shouldShowAccountBalanceOnReceipt
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldSkipLinkedReturns: builder.mutation<
        UpdateCompanyShouldSkipLinkingReturnsRes,
        UpdateCompanyShouldSkipLinkingReturnsReq
      >({
        query: (r) => c.updateCompanyShouldSkipLinkingReturns(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldSkipLinkingReturns = request.shouldSkipLinkingReturns
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyDefaultReceiptQuantity: builder.mutation<
        UpdateCompanyDefaultReceiptQuantityRes,
        UpdateCompanyDefaultReceiptQuantityReq
      >({
        query: (r) => c.updateCompanyDefaultReceiptQuantity(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.printerSettings = PrinterSettings.create({
                ...c.printerSettings,
                defaultReceiptQuantity: request.defaultReceiptQuantity,
              })
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyQuickPrintSettings: builder.mutation<
        UpdateCompanyQuickPrintSettingsRes,
        UpdateCompanyQuickPrintSettingsReq
      >({
        query: (r) => c.updateCompanyQuickPrintSettings(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.printerSettings = PrinterSettings.create({
                ...c.printerSettings,
                shouldQuickPrintThermal: request.shouldQuickPrintThermal,
                shouldQuickPrintFullPage: request.shouldQuickPrintFullPage,
                quickPrintShowPrices: request.quickPrintShowPrices,
                shouldAutoPrintNewSalesAndReceivables:
                  request.shouldAutoPrintNewSalesAndReceivables,
                shouldAutoPrintCompletedSalesAndReceivables:
                  request.shouldAutoPrintCompletedSalesAndReceivables,
              })
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyQuickPrintPrinterByLocation: builder.mutation<
        UpdateCompanyQuickPrintPrinterByLocationRes,
        UpdateCompanyQuickPrintPrinterByLocationReq
      >({
        query: (r) => c.updateCompanyQuickPrintPrinterByLocation(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          if (!request.locationId) {
            return
          }
          const key = UUID.idString(request.locationId)
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              const settingsByLocationId = {
                ...c.printerSettings?.settingsByLocationId,
              }
              if (request.printerId) {
                settingsByLocationId[key] = PrinterLocationSettings.create({
                  quickPrintPrinterId: request.printerId,
                })
              } else {
                delete settingsByLocationId[key]
              }
              c.printerSettings = PrinterSettings.create({
                ...c.printerSettings,
                settingsByLocationId,
              })
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyIsDoubleSidedStatementPrintingEnabled: builder.mutation<
        UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes,
        UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq
      >({
        query: (r) => c.updateCompanyIsDoubleSidedStatementPrintingEnabled(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isDoubleSidedStatementPrintingEnabled =
                request.isDoubleSidedStatementPrintingEnabled
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldHideNetZeroActivitiesOnStatements: builder.mutation<
        UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes,
        UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq
      >({
        query: (r) => c.updateCompanyShouldHideNetZeroActivitiesOnStatements(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldHideNetZeroActivitiesOnStatements =
                request.shouldHideNetZeroActivitiesOnStatements
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldRequireCustomerOnSale: builder.mutation<
        UpdateCompanyShouldRequireCustomerOnSaleRes,
        UpdateCompanyShouldRequireCustomerOnSaleReq
      >({
        query: (r) => c.updateCompanyShouldRequireCustomerOnSale(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldRequireCustomerOnSale =
                request.shouldRequireCustomerOnSale
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyCustomEmailConfig: builder.mutation<
        UpdateCompanyCustomEmailConfigRes,
        UpdateCompanyCustomEmailConfigReq
      >({
        query: (r) => c.updateCompanyCustomEmailConfig(r),
        invalidatesTags: ["Company"],
      }),
      validateCompanyCustomEmailConfig: builder.mutation<
        ValidateCompanyCustomEmailConfigRes,
        ValidateCompanyCustomEmailConfigReq
      >({
        query: (r) => c.validateCompanyCustomEmailConfig(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyStartInventoryCountsAtOnHand: builder.mutation<
        UpdateCompanyStartInventoryCountsAtOnHandRes,
        UpdateCompanyStartInventoryCountsAtOnHandReq
      >({
        query: (r) => c.updateCompanyStartInventoryCountsAtOnHand(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.startInventoryCountsAtOnHand =
                request.startInventoryCountsAtOnHand
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      getStripeExpressOnboardingURL: builder.query<
        GetStripeOnboardingURLRes,
        GetStripeOnboardingURLReq
      >({
        query: (r) => c.getStripeOnboardingURL(r),
      }),
      getStripeCustomOnboardingURL: builder.query<
        GetStripeOnboardingURLRes,
        GetStripeOnboardingURLReq
      >({
        query: (r) => c.getStripeCustomOnboardingURL(r),
      }),
      getStripeLoginURL: builder.query<
        GetStripeLoginURLRes,
        GetStripeLoginURLReq
      >({
        query: (r) => c.getStripeLoginURL(r),
      }),
      getStripeAccountSession: builder.query<
        GetStripeAccountSessionRes,
        GetStripeAccountSessionReq
      >({
        query: (r) => c.getStripeAccountSession(r),
      }),
      getIsStripePaymentsReady: builder.query<
        GetIsStripePaymentsReadyRes,
        GetIsStripePaymentsReadyReq
      >({
        query: (r) => c.getIsStripePaymentsReady(r),
      }),
      createCardSetupIntentForEntity: builder.mutation<
        CreateCardSetupIntentForEntityRes,
        CreateCardSetupIntentForEntityReq
      >({
        query: (r) => c.createCardSetupIntentForEntity(r),
      }),
      getEntityBillingInfo: builder.query<
        GetEntityBillingInfoRes,
        GetEntityBillingInfoReq
      >({
        query: (r) => c.getEntityBillingInfo(r),
        providesTags: ["EntityBilling"],
      }),
      getNeedsBillingPaymentMethod: builder.query<
        GetNeedsBillingPaymentMethodRes,
        GetNeedsBillingPaymentMethodReq
      >({
        query: (r) => c.getNeedsBillingPaymentMethod(r),
        providesTags: ["EntityBilling"],
      }),
      setEntityDefaultPaymentMethod: builder.mutation<
        SetEntityDefaultPaymentMethodRes,
        SetEntityDefaultPaymentMethodReq
      >({
        query: (r) => c.setEntityDefaultPaymentMethod(r),
        invalidatesTags: ["EntityBilling"],
      }),
      listAgreementsForCompany: builder.query<
        ListAgreementsForCompanyRes,
        ListAgreementsForCompanyReq
      >({
        query: (r) => c.listAgreementsForCompany(r),
      }),
      getAgreementPDFForCompany: builder.query<
        GetAgreementPDFForCompanyRes,
        GetAgreementPDFForCompanyReq
      >({
        query: (r) => c.getAgreementPDFForCompany(r),
      }),
      updateCardSurchargeRateSettings: builder.mutation<
        UpdateCardSurchargeRateRes,
        UpdateCardSurchargeRateReq
      >({
        query: (r) => c.updateCardSurchargeRate(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyDefaultDepositRate: builder.mutation<
        UpdateCompanyDefaultDepositRateRes,
        UpdateCompanyDefaultDepositRateReq
      >({
        query: (r) => c.updateCompanyDefaultDepositRate(r),
        invalidatesTags: ["Company"],
      }),
      updateCostManagementSettings: builder.mutation<
        UpdateCostManagementSettingsRes,
        UpdateCostManagementSettingsReq
      >({
        query: (r) => c.updateCostManagementSettings(r),
        invalidatesTags: ["Company"],
      }),
      updateCompanyPreserveSaleProductPriceEdits: builder.mutation<
        UpdateCompanyPreserveSaleProductPriceEditsRes,
        UpdateCompanyPreserveSaleProductPriceEditsReq
      >({
        query: (r) => c.updateCompanyPreserveSaleProductPriceEdits(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.preserveSaleProductPriceEdits =
                req.preserveSaleProductPriceEdits
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldRequireInternalSaleNotesByDefault: builder.mutation<
        UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes,
        UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq
      >({
        query: (r) => c.updateCompanyShouldRequireInternalSaleNotesByDefault(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldRequireInternalSaleNotesByDefault =
                request.shouldRequireInternalSaleNotesByDefault
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldRequireVoidReason: builder.mutation<
        UpdateCompanyShouldRequireVoidReasonRes,
        UpdateCompanyShouldRequireVoidReasonReq
      >({
        query: (r) => c.updateCompanyShouldRequireVoidReason(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldRequireVoidReason = request.shouldRequireVoidReason
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyAllowDifferentFulfillmentLocation: builder.mutation<
        UpdateCompanyAllowDifferentFulfillmentLocationRes,
        UpdateCompanyAllowDifferentFulfillmentLocationReq
      >({
        query: (r) => c.updateCompanyAllowDifferentFulfillmentLocation(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.allowDifferentFulfillmentLocation =
                request.allowDifferentFulfillmentLocation
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateCompanyShouldAutoApplyCreditsOnStatements: builder.mutation<
        UpdateCompanyShouldAutoApplyCreditsOnStatementsRes,
        UpdateCompanyShouldAutoApplyCreditsOnStatementsReq
      >({
        query: (r) => c.updateCompanyShouldAutoApplyCreditsOnStatements(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.shouldAutoApplyCreditsOnStatements =
                request.shouldAutoApplyCreditsOnStatements
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      /* Location */
      getLocation: builder.query<GetLocationRes, GetLocationReq>({
        query: (r) => c.getLocation(r),
        providesTags: (_response, _error, request) => [
          {
            type: "Location",
            id: request.locationId
              ? UUID.fromPB(request.locationId).toString()
              : "",
          },
        ],
      }),
      listLocationsForCompany: builder.query<
        ListLocationsForCompanyRes,
        ListLocationsForCompanyReq
      >({
        query: (r) => c.listLocationsForCompany(r),
        providesTags: ["Location"],
      }),
      listCardReadersForLocation: builder.query<
        ListCardReadersForLocationRes,
        ListCardReadersForLocationReq
      >({
        query: ({ locationId }) => c.listCardReadersForLocation({ locationId }),
        providesTags: ["Location"],
      }),
      createLocation: builder.mutation<CreateLocationRes, CreateLocationReq>({
        query: (r) => c.createLocation(r),
        invalidatesTags: ["Location", "TaxRate"],
      }),
      updateLocation: builder.mutation<UpdateLocationRes, UpdateLocationReq>({
        query: (r) => c.updateLocation(r),
        invalidatesTags: ["Location", "TaxRate"],
      }),
      updateLocationGoogleReviewUrl: builder.mutation<
        UpdateLocationGoogleReviewUrlRes,
        UpdateLocationGoogleReviewUrlReq
      >({
        query: (r) => c.updateLocationGoogleReviewUrl(r),
        invalidatesTags: (_res, _err, req) => [
          {
            type: "Location",
            id: UUID.idString(req.locationId),
          },
        ],
      }),
      updateLocationIsActive: builder.mutation<
        UpdateLocationIsActiveRes,
        UpdateLocationIsActiveReq
      >({
        query: (r) => c.updateLocationIsActive(r),
        invalidatesTags: (_res, _err, req) => [
          {
            type: "Location",
            id: UUID.idString(req.locationId),
          },
        ],
      }),
      updateLocationCashDrawers: builder.mutation<
        UpdateLocationCashDrawersRes,
        UpdateLocationCashDrawersReq
      >({
        query: (r) => c.updateLocationCashDrawers(r),
        invalidatesTags: (_res, _err, req) => [
          {
            type: "Location",
            id: UUID.idString(req.locationId),
          },
        ],
      }),
      updateLocationQuickbooksClass: builder.mutation<
        UpdateLocationQuickbooksClassRes,
        UpdateLocationQuickbooksClassReq
      >({
        query: (r) => c.updateLocationQuickbooksClass(r),
        invalidatesTags: (_res, _err, req) => [
          {
            type: "Location",
            id: UUID.idString(req.locationId),
          },
        ],
      }),
      updateLocationBMOutletNumber: builder.mutation<
        UpdateLocationBMOutletNumberRes,
        UpdateLocationBMOutletNumberReq
      >({
        query: (r) => c.updateLocationBMOutletNumber(r),
        invalidatesTags: (_res, _err, req) => [
          {
            type: "Location",
            id: UUID.idString(req.locationId),
          },
        ],
      }),
      updateLocationLogoImageUrl: builder.mutation<
        UpdateLocationLogoImageUrlRes,
        UpdateLocationLogoImageUrlReq
      >({
        query: (r) => c.updateLocationLogoImageUrl(r),
        invalidatesTags: (_res, _err, req) => [
          {
            type: "Location",
            id: UUID.idString(req.locationId),
          },
        ],
      }),
      updateLocationStatementMessage: builder.mutation<
        UpdateLocationStatementMessageRes,
        UpdateLocationStatementMessageReq
      >({
        query: (r) => c.updateLocationStatementMessage(r),
        invalidatesTags: (_res, _err, req) => [
          {
            type: "Location",
            id: UUID.idString(req.locationId),
          },
        ],
      }),

      /* Staff */
      getStaff: builder.query<GetStaffRes, GetStaffReq>({
        query: (r) => c.getStaff(r),
        providesTags: (_response, _error, request) => [
          { type: "Staff", id: UUID.fromPB(request.id!).toString() },
        ],
      }),
      validateStaffAttributionPin: builder.mutation<
        ValidateStaffAttributionPinRes,
        ValidateStaffAttributionPinReq
      >({
        query: (r) => c.validateStaffAttributionPin(r),
        invalidatesTags: ["CurrentUser"],
      }),
      clearStaffAttributionPin: builder.mutation<
        ClearStaffAttributionPinRes,
        ClearStaffAttributionPinReq
      >({
        query: (r) => c.clearStaffAttributionPin(r),
        invalidatesTags: ["CurrentUser"],
      }),
      listStaffsForCompany: builder.query<
        ListStaffsForCompanyRes,
        ListStaffsForCompanyReq
      >({
        query: (r) => c.listStaffsForCompany(r),
        providesTags: ["Staff"],
      }),
      updateStaff: builder.mutation<UpdateStaffRes, UpdateStaffReq>({
        query: (r) => c.updateStaff(r),
        invalidatesTags: ["Staff"],
      }),
      updateStaffIsAttributionEnabled: builder.mutation<
        UpdateStaffIsAttributionEnabledRes,
        UpdateStaffIsAttributionEnabledReq
      >({
        query: (r) => c.updateStaffIsAttributionEnabled(r),
        invalidatesTags: (_response, _error, request) => [
          { type: "Staff", id: UUID.idString(request.id) },
        ],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = companyApiSlice.util
            .selectInvalidatedBy(getState(), [
              { type: "Staff", id: UUID.idString(request.id) },
            ])
            .filter(({ endpointName }) => endpointName === "getStaff")
            .map(({ originalArgs }) =>
              dispatch(
                companyApiSlice.util.updateQueryData(
                  "getStaff",
                  originalArgs,
                  ({ staff }) => {
                    if (!staff) {
                      return
                    }

                    staff.isAttributionEnabled = request.isAttributionEnabled
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      deactivateStaff: builder.mutation<DeactivateStaffRes, DeactivateStaffReq>(
        {
          query: (r) => c.deactivateStaff(r),
          invalidatesTags: ["Staff"],
        }
      ),
      reactivateStaff: builder.mutation<ReactivateStaffRes, ReactivateStaffReq>(
        {
          query: (r) => c.reactivateStaff(r),
          invalidatesTags: ["Staff"],
        }
      ),
      deactivateStaffWebAuthnKeys: builder.mutation<
        DeactivateStaffWebAuthnKeysRes,
        DeactivateStaffWebAuthnKeysReq
      >({
        query: (r) => c.deactivateStaffWebAuthnKeys(r),
        invalidatesTags: ["Staff"],
      }),
      listAuthorizedEndpoints: builder.query<
        ListAuthorizedEndpointsRes,
        ListAuthorizedEndpointsReq
      >({
        query: (r) => c.listAuthorizedEndpoints(r),
      }),
      updateStaffPermissions: builder.mutation<
        UpdateStaffPermissionsRes,
        UpdateStaffPermissionsReq
      >({
        query: (r) => c.updateStaffPermissions(r),
        invalidatesTags: ["Staff"],
      }),
      bulkUpsertStaff: builder.mutation<BulkUpsertStaffRes, BulkUpsertStaffReq>(
        {
          query: (r) => c.bulkUpsertStaff(r),
        }
      ),

      createStaff: builder.mutation<CreateStaffRes, CreateStaffReq>({
        query: (r) => c.createStaff(r),
        invalidatesTags: ["Staff"],
      }),

      /* Tender Methods */
      listDrawerMethods: builder.query<
        ListDrawerMethodsRes,
        ListDrawerMethodsReq
      >({
        query: (r) => c.listDrawerMethods(r),
        providesTags: ["TenderMethod"],
      }),
      createCustomTenderMethod: builder.mutation<
        CreateCustomTenderMethodRes,
        CreateCustomTenderMethodReq
      >({
        query: (r) => c.createCustomTenderMethod(r),
        invalidatesTags: ["TenderMethod"],
      }),
      updateCustomTenderMethod: builder.mutation<
        UpdateCustomTenderMethodRes,
        UpdateCustomTenderMethodReq
      >({
        query: (r) => c.updateCustomTenderMethod(r),
        invalidatesTags: ["TenderMethod"],
      }),
      updateDefaultTenderMethodUsages: builder.mutation<
        UpdateDefaultTenderMethodUsagesRes,
        UpdateDefaultTenderMethodUsagesReq
      >({
        query: (r) => c.updateDefaultTenderMethodUsages(r),
        invalidatesTags: ["TenderMethod"],
      }),
      deactivateCustomTenderMethod: builder.mutation<
        DeactivateCustomTenderMethodReq,
        DeactivateCustomTenderMethodRes
      >({
        query: (r) => c.deactivateCustomTenderMethod(r),
        invalidatesTags: ["TenderMethod"],
      }),
      activateCustomTenderMethod: builder.mutation<
        ActivateCustomTenderMethodRes,
        ActivateCustomTenderMethodReq
      >({
        query: (r) => c.activateCustomTenderMethod(r),
        invalidatesTags: ["TenderMethod"],
      }),
      reorderTenderMethods: builder.mutation<
        ReorderTenderMethodsRes,
        ReorderTenderMethodsReq
      >({
        query: (r) => c.reorderTenderMethods(r),
        invalidatesTags: ["TenderMethod"],
      }),
      getIsGiftCardsEnabled: builder.query<
        GetIsGiftCardsEnabledRes,
        GetIsGiftCardsEnabledReq
      >({
        query: (r) => c.getIsGiftCardsEnabled(r),
      }),

      /* User */
      getCurrentUser: builder.query<GetCurrentUserRes, GetCurrentUserReq>({
        query: (r) => c.getCurrentUser(r),
        providesTags: ["CurrentUser"],
      }),
      getCurrentUserIsAttributionEnabled: builder.query<
        GetCurrentUserIsAttributionEnabledRes,
        GetCurrentUserIsAttributionEnabledReq
      >({
        query: (r) => c.getCurrentUserIsAttributionEnabled(r),
      }),

      /* Pricing Tier */
      listPricingTiersForCompany: builder.query<
        ListPricingTiersForCompanyRes,
        ListPricingTiersForCompanyReq
      >({
        query: (r) => c.listPricingTiersForCompany(r),
        providesTags: ["PricingTier"],
      }),
      listCustomersForTier: builder.query<
        ListCustomersForTierRes,
        ListCustomersForTierReq
      >({
        query: (r) => c.listCustomersForTier(r),
        providesTags: ["PricingTier"],
      }),
      createPricingTier: builder.mutation<
        CreatePricingTierRes,
        CreatePricingTierReq
      >({
        query: (r) => c.createPricingTier(r),
        invalidatesTags: ["PricingTier"],
      }),
      updatePricingTier: builder.mutation<
        UpdatePricingTierRes,
        UpdatePricingTierReq
      >({
        query: (r) => c.updatePricingTier(r),
        invalidatesTags: ["PricingTier"],
      }),
      deletePricingTier: builder.mutation<
        DeletePricingTierRes,
        DeletePricingTierReq
      >({
        query: (r) => c.deletePricingTier(r),
        invalidatesTags: ["PricingTier"],
      }),
      reorderPricingTiers: builder.mutation<
        ReorderPricingTiersRes,
        ReorderPricingTiersReq
      >({
        query: (r) => c.reorderPricingTiers(r),
        invalidatesTags: ["PricingTier"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            companyApiSlice.util.updateQueryData(
              "listPricingTiersForCompany",
              {},
              ({ tiers }) => {
                for (const [i, tier] of tiers.entries()) {
                  tiers[i].rank = request.idStrings.indexOf(tier.idString) + 1
                }

                tiers.sort((a, b) => {
                  if (a.rank < b.rank) {
                    return -1
                  }
                  if (a.rank > b.rank) {
                    return 1
                  }
                  return 0
                })
              }
            )
          )

          queryFulfilled.catch(patchResult.undo)
        },
      }),

      /* Financing Term */
      listFinancingTermsForCompany: builder.query<
        ListFinancingTermsForCompanyRes,
        ListFinancingTermsForCompanyReq
      >({
        query: (r) => c.listFinancingTermsForCompany(r),
        providesTags: ["FinancingTerm"],
      }),
      listCustomersForTerm: builder.query<
        ListCustomersForTermRes,
        ListCustomersForTermReq
      >({
        query: (r) => c.listCustomersForTerm(r),
      }),
      createFinancingTerm: builder.mutation<
        CreateFinancingTermRes,
        CreateFinancingTermReq
      >({
        query: (r) => c.createFinancingTerm(r),
        invalidatesTags: ["FinancingTerm"],
      }),
      updateFinancingTerm: builder.mutation<
        UpdateFinancingTermRes,
        UpdateFinancingTermReq
      >({
        query: (r) => c.updateFinancingTerm(r),
        invalidatesTags: ["FinancingTerm"],
      }),
      deleteFinancingTerm: builder.mutation<
        DeleteFinancingTermRes,
        DeleteFinancingTermReq
      >({
        query: (r) => c.deleteFinancingTerm(r),
        invalidatesTags: ["FinancingTerm"],
      }),
      reorderFinancingTerms: builder.mutation<
        ReorderFinancingTermsRes,
        ReorderFinancingTermsReq
      >({
        query: (r) => c.reorderFinancingTerms(r),
        invalidatesTags: ["FinancingTerm"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            companyApiSlice.util.updateQueryData(
              "listFinancingTermsForCompany",
              {},
              ({ terms }) => {
                for (const [i, term] of terms.entries()) {
                  terms[i].position =
                    request.idStrings.indexOf(term.idString) + 1
                }

                terms.sort((a, b) => {
                  if (a.position < b.position) {
                    return -1
                  }
                  if (a.position > b.position) {
                    return 1
                  }
                  return 0
                })
              }
            )
          )

          queryFulfilled.catch(patchResult.undo)
        },
      }),

      /* Product Category V2*/
      listProductCategoriesForCompanyV2: builder.query<
        ListProductCategoriesForCompanyV2Res,
        ListProductCategoriesForCompanyV2Req
      >({
        query: (r) => c.listProductCategoriesForCompanyV2(r),
        providesTags: ["ProductCategoryV2"],
      }),
      createProductCategoryV2: builder.mutation<
        CreateProductCategoryV2Res,
        CreateProductCategoryV2Req
      >({
        query: (r) => c.createProductCategoryV2(r),
        invalidatesTags: ["ProductCategoryV2"],
      }),
      updateProductCategoryV2: builder.mutation<
        UpdateProductCategoryV2Res,
        UpdateProductCategoryV2Req
      >({
        query: (r) => c.updateProductCategoryV2(r),
        invalidatesTags: ["ProductCategoryV2", "ProductCategoryTree"],
      }),
      deactivateProductCategoryV2: builder.mutation<
        DeactivateProductCategoryV2Res,
        DeactivateProductCategoryV2Req
      >({
        query: (r) => c.deactivateProductCategoryV2(r),
        invalidatesTags: ["ProductCategoryV2", "ProductCategoryTree"],
      }),
      bulkUpsertDepartments: builder.mutation<
        BulkUpsertDepartmentsRes,
        BulkUpsertDepartmentsReq
      >({
        query: (r) => c.bulkUpsertDepartments(r),
        invalidatesTags: ["ProductCategoryV2", "ProductCategoryTree"],
      }),
      bulkUpsertClasses: builder.mutation<
        BulkUpsertClassesRes,
        BulkUpsertClassesReq
      >({
        query: (r) => c.bulkUpsertClasses(r),
        invalidatesTags: ["ProductCategoryV2", "ProductCategoryTree"],
      }),
      bulkUpsertFinelines: builder.mutation<
        BulkUpsertFinelineRes,
        BulkUpsertFinelineReq
      >({
        query: (r) => c.bulkUpsertFinelines(r),
        invalidatesTags: ["ProductCategoryV2", "ProductCategoryTree"],
      }),
      listProductsForCategoryV2: builder.query<
        ListProductsForCategoryV2Res,
        ListProductsForCategoryV2Req
      >({
        query: (r) => c.listProductsForCategoryV2(r),
      }),
      getProductCategoryTree: builder.query<
        GetProductCategoryTreeRes,
        GetProductCategoryTreeReq
      >({
        query: (r) => c.getProductCategoryTree(r),
        providesTags: ["ProductCategoryTree"],
      }),

      /* Additional Fee */
      listAdditionalFeesForCompany: builder.query<
        ListAdditionalFeesForCompanyRes,
        ListAdditionalFeesForCompanyReq
      >({
        query: (r) => c.listAdditionalFeesForCompany(r),
        providesTags: ["AdditionalFee"],
      }),
      listProductsForFee: builder.query<
        ListProductsForFeeRes,
        ListProductsForFeeReq
      >({
        query: (r) => c.listProductsForFee(r),
      }),
      createAdditionalFee: builder.mutation<
        CreateAdditionalFeeRes,
        CreateAdditionalFeeReq
      >({
        query: (r) => c.createAdditionalFee(r),
        invalidatesTags: ["AdditionalFee"],
      }),
      updateAdditionalFee: builder.mutation<
        UpdateAdditionalFeeRes,
        UpdateAdditionalFeeReq
      >({
        query: (r) => c.updateAdditionalFee(r),
        invalidatesTags: ["AdditionalFee"],
      }),
      deleteAdditionalFee: builder.mutation<
        DeleteAdditionalFeeRes,
        DeleteAdditionalFeeReq
      >({
        query: (r) => c.deleteAdditionalFee(r),
        invalidatesTags: ["AdditionalFee"],
      }),
      reorderAdditionalFees: builder.mutation<
        ReorderAdditionalFeesRes,
        ReorderAdditionalFeesReq
      >({
        query: (r) => c.reorderAdditionalFees(r),
        invalidatesTags: ["AdditionalFee"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            companyApiSlice.util.updateQueryData(
              "listAdditionalFeesForCompany",
              {},
              ({ fees }) => {
                for (const [i, tier] of fees.entries()) {
                  fees[i].position =
                    request.idStrings.indexOf(tier.idString) + 1
                }

                fees.sort((a, b) => {
                  if (a.position < b.position) {
                    return -1
                  }
                  if (a.position > b.position) {
                    return 1
                  }
                  return 0
                })
              }
            )
          )

          queryFulfilled.catch(patchResult.undo)
        },
      }),
      clearCardReader: builder.mutation<ClearCardReaderRes, ClearCardReaderReq>(
        {
          query: (r) => c.clearCardReader(r),
        }
      ),
      listTaxRatesForCompany: builder.query<
        ListTaxRatesForCompanyRes,
        ListTaxRatesForCompanyReq
      >({
        query: (r) => c.listTaxRatesForCompany(r),
        providesTags: ["TaxRate"],
      }),
      createCustomTaxRate: builder.mutation<
        CreateCustomTaxRateRes,
        CreateCustomTaxRateReq
      >({
        query: (r) => c.createCustomTaxRate(r),
        invalidatesTags: ["TaxRate"],
      }),
      updateCustomTaxRate: builder.mutation<
        UpdateCustomTaxRateRes,
        UpdateCustomTaxRateReq
      >({
        query: (r) => c.updateCustomTaxRate(r),
        invalidatesTags: ["TaxRate"],
      }),
      reorderCustomTaxRates: builder.mutation<
        ReorderCustomTaxRatesRes,
        ReorderCustomTaxRatesReq
      >({
        query: (r) => c.reorderCustomTaxRates(r),
        invalidatesTags: ["TaxRate"],
        onQueryStarted: async (
          request,
          { dispatch, queryFulfilled, getState }
        ) => {
          const patchResults = companyApiSlice.util
            .selectInvalidatedBy(getState(), ["TaxRate"])
            .filter(
              ({ endpointName }) => endpointName === "listTaxRatesForCompany"
            )
            .map(({ originalArgs }) =>
              dispatch(
                companyApiSlice.util.updateQueryData(
                  "listTaxRatesForCompany",
                  originalArgs,
                  ({ taxRates }) => {
                    for (const customTaxRate of taxRates) {
                      const idx = request.ids.findIndex((id) =>
                        UUID.eqFromPB(id, customTaxRate.id)
                      )
                      customTaxRate.position = idx + 1
                    }

                    taxRates.sort((a, b) => {
                      if (a.position < b.position) {
                        return -1
                      }
                      if (a.position > b.position) {
                        return 1
                      }
                      return 0
                    })
                  }
                )
              )
            )

          try {
            await queryFulfilled
          } catch {
            for (const patchResult of patchResults) {
              patchResult.undo()
            }
          }
        },
      }),
      deactivateCustomTaxRate: builder.mutation<
        DeactivateCustomTaxRateRes,
        DeactivateCustomTaxRateReq
      >({
        query: (r) => c.deactivateCustomTaxRate(r),
        invalidatesTags: ["TaxRate"],
      }),
      listTaxRatesForLocation: builder.query<
        ListTaxRatesForLocationRes,
        ListTaxRatesForLocationReq
      >({
        query: (r) => c.listTaxRatesForLocation(r),
        providesTags: (_response, _error, request) => [
          {
            type: "TaxRate",
            id: UUID.idString(request.locationId),
          },
        ],
      }),
      getOrCreateCustomTaxRateForAddress: builder.mutation<
        GetOrCreateCustomTaxRateForAddressRes,
        GetOrCreateCustomTaxRateForAddressReq
      >({
        query: (r) => c.getOrCreateCustomTaxRateForAddress(r),
        invalidatesTags: ["TaxRate"],
      }),

      /* Roles */
      getPermissionsGroups: builder.query<
        GetPermissionsGroupsRes,
        GetPermissionsGroupsReq
      >({
        query: (r) => c.getPermissionsGroups(r),
        providesTags: ["PermissionsGroups"],
      }),

      /* Finance Charge Setting */
      createFinanceChargeSetting: builder.mutation<
        CreateFinanceChargeSettingRes,
        CreateFinanceChargeSettingReq
      >({
        query: (r) => c.createFinanceChargeSetting(r),
        invalidatesTags: ["FinanceChargeSetting"],
      }),
      updateFinanceChargeSetting: builder.mutation<
        UpdateFinanceChargeSettingRes,
        UpdateFinanceChargeSettingReq
      >({
        query: (r) => c.updateFinanceChargeSetting(r),
        invalidatesTags: ["FinanceChargeSetting"],
      }),
      listActiveFinanceChargeSettingsForCompany: builder.query<
        ListActiveFinanceChargeSettingsForCompanyRes,
        ListActiveFinanceChargeSettingsForCompanyReq
      >({
        query: (r) => c.listActiveFinanceChargeSettingsForCompany(r),
        providesTags: ["FinanceChargeSetting"],
      }),
      deactivateFinanceChargeSetting: builder.mutation<
        DeactivateFinanceChargeSettingRes,
        DeactivateFinanceChargeSettingReq
      >({
        query: (r) => c.deactivateFinanceChargeSetting(r),
        invalidatesTags: ["FinanceChargeSetting"],
      }),
      reorderFinanceChargeSettings: builder.mutation<
        ReorderFinanceChargeSettingsRes,
        ReorderFinanceChargeSettingsReq
      >({
        query: (r) => c.reorderFinanceChargeSettings(r),
        invalidatesTags: ["FinanceChargeSetting"],
        onQueryStarted: (request, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            companyApiSlice.util.updateQueryData(
              "listActiveFinanceChargeSettingsForCompany",
              {},
              ({ financeChargeSettings }) => {
                financeChargeSettings.forEach((charge) => {
                  const idx = request.ids.findIndex((id: PBUUID) =>
                    UUID.fromPB(id).eq(UUID.fromPB(charge.id!))
                  )
                  charge.position = idx + 1
                })
                financeChargeSettings.sort((a, b) => a.position - b.position)
              }
            )
          )

          queryFulfilled.catch(patchResult.undo)
        },
      }),
      listCustomersForFinanceChargeSetting: builder.query<
        ListCustomersForFinanceChargeSettingRes,
        ListCustomersForFinanceChargeSettingReq
      >({
        query: (r) => c.listCustomersForFinanceChargeSetting(r),
        providesTags: ["FinanceChargeSetting"],
      }),
      createSaleForm: builder.mutation<CreateSaleFormRes, CreateSaleFormReq>({
        query: (r) => c.createSaleForm(r),
        invalidatesTags: ["SaleForm"],
      }),
      updateSaleForm: builder.mutation<UpdateSaleFormRes, UpdateSaleFormReq>({
        query: (r) => c.updateSaleForm(r),
        invalidatesTags: ["SaleForm"],
      }),
      listSaleForms: builder.query<ListSaleFormsRes, ListSaleFormsReq>({
        query: (r) => c.listSaleForms(r),
        providesTags: ["SaleForm"],
      }),
      deleteSaleForm: builder.mutation<DeleteSaleFormRes, DeleteSaleFormReq>({
        query: (r) => c.deleteSaleForm(r),
        invalidatesTags: ["SaleForm"],
      }),
      /* Entities */
      listEntitiesForCompany: builder.query<ListEntitiesRes, ListEntitiesReq>({
        query: (r) => c.listEntitiesForCompany(r),
        providesTags: ["Entity"],
      }),
      /* Units of Measure */
      listUnitsOfMeasureForCompany: builder.query<
        ListUnitsOfMeasureForCompanyRes,
        ListUnitsOfMeasureForCompanyReq
      >({
        query: (r) => c.listUnitsOfMeasureForCompany(r),
        providesTags: ["UnitOfMeasure"],
      }),
      addCompanyUnitOfMeasure: builder.mutation<
        AddCompanyUnitOfMeasureRes,
        AddCompanyUnitOfMeasureReq
      >({
        query: (r) => c.addCompanyUnitOfMeasure(r),
        invalidatesTags: ["UnitOfMeasure"],
      }),
      updateCompanyUnitOfMeasure: builder.mutation<
        UpdateCompanyUnitOfMeasureRes,
        UpdateCompanyUnitOfMeasureReq
      >({
        query: (r) => c.updateCompanyUnitOfMeasure(r),
        invalidatesTags: ["UnitOfMeasure"],
      }),
      deleteCompanyUnitOfMeasure: builder.mutation<
        DeleteCompanyUnitOfMeasureRes,
        DeleteCompanyUnitOfMeasureReq
      >({
        query: (r) => c.deleteCompanyUnitOfMeasure(r),
        invalidatesTags: ["UnitOfMeasure"],
      }),
      bulkUpsertUnitsOfMeasure: builder.mutation<
        BulkUpsertUnitsOfMeasureRes,
        BulkUpsertUnitsOfMeasureReq
      >({
        query: (r) => c.bulkUpsertUnitsOfMeasure(r),
        invalidatesTags: ["UnitOfMeasure"],
      }),
      getIsBankingPermitted: builder.query<
        GetIsBankingPermittedRes,
        GetIsBankingPermittedReq
      >({
        query: (r) => c.getIsBankingPermitted(r),
        providesTags: ["Company"],
      }),

      /* Pricing Regions */
      listPricingRegionsForCompany: builder.query<
        ListPricingRegionsForCompanyRes,
        ListPricingRegionsForCompanyReq
      >({
        query: (r) => c.listPricingRegionsForCompany(r),
        providesTags: ["PricingRegion"],
      }),
      updateCompanyIsPricingByRegionEnabled: builder.mutation<
        UpdateCompanyIsPricingByRegionEnabledRes,
        UpdateCompanyIsPricingByRegionEnabledReq
      >({
        query: (r) => c.updateCompanyIsPricingByRegionEnabled(r),
        invalidatesTags: ["Company"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            patchGetCompanyQueryData((c) => {
              c.isPricingByRegionEnabled = req.isPricingByRegionEnabled
            })
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateLocationPricingRegion: builder.mutation<
        UpdateLocationPricingRegionRes,
        UpdateLocationPricingRegionReq
      >({
        query: (r) => c.updateLocationPricingRegion(r),
        invalidatesTags: ["Location"],
      }),
      updateLocationCashRounding: builder.mutation<
        UpdateLocationCashRoundingRes,
        UpdateLocationCashRoundingReq
      >({
        query: (r) => c.updateLocationCashRounding(r),
        invalidatesTags: ["Location"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            companyApiSlice.util.updateQueryData(
              "getLocation",
              { locationId: req.locationId },
              ({ location }) => {
                if (!location) {
                  return
                }
                location.cashRounding = req.cashRounding
              }
            )
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      updateLocationShowInventory: builder.mutation<
        UpdateLocationShowInventoryRes,
        UpdateLocationShowInventoryReq
      >({
        query: (r) => c.updateLocationShowInventory(r),
        invalidatesTags: ["Location"],
        onQueryStarted: (req, { dispatch, queryFulfilled }) => {
          const patchResult = dispatch(
            companyApiSlice.util.updateQueryData(
              "getLocation",
              { locationId: req.locationId },
              ({ location }) => {
                if (!location) {
                  return
                }
                location.showInventory = req.showInventory
              }
            )
          )
          queryFulfilled.catch(patchResult.undo)
        },
      }),
      createPricingRegion: builder.mutation<
        CreatePricingRegionRes,
        CreatePricingRegionReq
      >({
        query: (r) => c.createPricingRegion(r),
        invalidatesTags: ["PricingRegion"],
      }),
      updatePricingRegionName: builder.mutation<
        UpdatePricingRegionNameRes,
        UpdatePricingRegionNameReq
      >({
        query: (r) => c.updatePricingRegionName(r),
        invalidatesTags: ["PricingRegion"],
      }),
      deactivatePricingRegion: builder.mutation<
        DeactivatePricingRegionRes,
        DeactivatePricingRegionReq
      >({
        query: (r) => c.deactivatePricingRegion(r),
        invalidatesTags: ["PricingRegion"],
      }),
      reorderPricingRegions: builder.mutation<
        ReorderPricingRegionsRes,
        ReorderPricingRegionsReq
      >({
        query: (r) => c.reorderPricingRegions(r),
        invalidatesTags: ["PricingRegion"],
      }),
    }),
  })

export const {
  /* Company */
  useGetCompanyForSubdomainQuery,
  useLazyGetCompanyForSubdomainQuery,
  useGetCompanyQuery,
  useLazyGetCompanyQuery,
  useGetStripeExpressOnboardingURLQuery,
  useLazyGetStripeExpressOnboardingURLQuery,
  useGetStripeCustomOnboardingURLQuery,
  useLazyGetStripeCustomOnboardingURLQuery,
  useGetStripeLoginURLQuery,
  useLazyGetStripeLoginURLQuery,
  useLazyGetStripeAccountSessionQuery,
  useGetIsStripePaymentsReadyQuery,
  useCreateCardSetupIntentForEntityMutation,
  useGetEntityBillingInfoQuery,
  useGetNeedsBillingPaymentMethodQuery,
  useLazyGetEntityBillingInfoQuery,
  useSetEntityDefaultPaymentMethodMutation,
  useListAgreementsForCompanyQuery,
  useLazyGetAgreementPDFForCompanyQuery,
  useUpdateCompanyGeneralSettingsMutation,
  useUpdateCompanySecuritySettingsMutation,
  useUpdateCompanyGeneralCommunicationsSettingsMutation,
  useUpdateCompanyIsLoyaltyProgramEnabledMutation,
  useUpdateCompanyEcommerceSettingsMutation,
  useUpdateCompanyIsCardSurchargeTaxExemptMutation,
  useUpdateCompanyLoyaltyProgramPolicyMutation,
  useUpdateCompanyStatementSettingsMutation,
  useUpdateCompanyShouldAutoApplyReturnCreditsMutation,
  useUpdateCompanyShouldHideReturnConfirmationMutation,
  useUpdateCompanyShouldAllowNonStockCostEditsMutation,
  useUpdateCompanyShouldAllowNonStockPriceCostEditsMutation,
  useUpdateCompanyShouldAllowReturnsWithoutNoteMutation,
  useUpdateCompanyShouldAutoSubmitContractorRewardsMutation,
  useUpdateCompanyIsBmDataSharingEnabledMutation,
  useUpdateCompanyContractorRewardsSettingsMutation,
  useUpdateCompanyIsDiscountShownToCustomersMutation,
  useUpdateCompanyIsDiscountPercentageShownOnReceiptMutation,
  useUpdateCompanyIsPriceShownOnWillCallMutation,
  useUpdateCompanyShouldShowCostsOnTransferPrintsMutation,
  useUpdateCompanyIsCartReaderSyncDisabledMutation,
  useUpdateCompanyTaxRateModeMutation,
  useUpdateCompanyIsFinancingTermsShownOnInvoiceMutation,
  useUpdateCardSurchargeRateSettingsMutation,
  useUpdateCompanyIsColorFormulaHiddenMutation,
  useUpdateCompanyIsDesignatedClerkEnabledMutation,
  useUpdateCompanyIsDepositsAndPartialFulfillmentEnabledMutation,
  useUpdateCompanyShouldHideCategoryBrowserMutation,
  useUpdateCompanyShouldAutoSignOutAfterSaleSettingsMutation,
  useUpdateCompanyDefaultDepositRateMutation,
  useUpdateCostManagementSettingsMutation,
  useUpdateCompanyShouldSetOrderedProductQuantityToZeroMutation,
  useUpdateCompanyShouldTriggerOrderWhenStockBelowMinMutation,
  useUpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostMutation,
  useUpdateCompanyProductImageSettingsMutation,
  useUpdateCompanyShouldShowAccountBalanceOnReceiptMutation,
  useUpdateCompanyShouldSkipLinkedReturnsMutation,
  useUpdateCompanyDefaultReceiptQuantityMutation,
  useUpdateCompanyQuickPrintSettingsMutation,
  useUpdateCompanyQuickPrintPrinterByLocationMutation,
  useUpdateCompanyPreserveSaleProductPriceEditsMutation,
  useUpdateCompanyShouldRequireInternalSaleNotesByDefaultMutation,
  useUpdateCompanyShouldRequireVoidReasonMutation,
  useUpdateCompanyShouldShowInventoryNegativeWarningMutation,
  useUpdateCompanyShouldWarnWhenSellingBelowCostMutation,
  useUpdateCompanyAllowDifferentFulfillmentLocationMutation,
  useUpdateCompanyShouldAutoApplyCreditsOnStatementsMutation,
  useUpdateCompanyIsDoubleSidedStatementPrintingEnabledMutation,
  useUpdateCompanyShouldHideNetZeroActivitiesOnStatementsMutation,
  useUpdateCompanyShouldRequireCustomerOnSaleMutation,
  useUpdateCompanyCustomEmailConfigMutation,
  useValidateCompanyCustomEmailConfigMutation,
  useUpdateCompanyStartInventoryCountsAtOnHandMutation,

  /* Location */
  useGetLocationQuery,
  useListLocationsForCompanyQuery,
  useLazyListLocationsForCompanyQuery,
  useListCardReadersForLocationQuery,
  useLazyListCardReadersForLocationQuery,
  useCreateLocationMutation,
  useUpdateLocationMutation,
  useClearCardReaderMutation,
  useUpdateLocationGoogleReviewUrlMutation,
  useUpdateLocationCashDrawersMutation,
  useUpdateLocationBMOutletNumberMutation,
  useUpdateLocationQuickbooksClassMutation,
  useUpdateLocationLogoImageUrlMutation,
  useUpdateLocationStatementMessageMutation,
  useUpdateLocationIsActiveMutation,
  useUpdateLocationPricingRegionMutation,
  useUpdateLocationCashRoundingMutation,
  useUpdateLocationShowInventoryMutation,

  /* Staff */
  useGetStaffQuery,
  useValidateStaffAttributionPinMutation,
  useClearStaffAttributionPinMutation,
  useGetCurrentUserQuery,
  useGetCurrentUserIsAttributionEnabledQuery,
  useLazyGetCurrentUserQuery,
  useListStaffsForCompanyQuery,
  useLazyListStaffsForCompanyQuery,
  useCreateStaffMutation,
  useUpdateStaffMutation,
  useUpdateStaffIsAttributionEnabledMutation,
  useDeactivateStaffMutation,
  useReactivateStaffMutation,
  useDeactivateStaffWebAuthnKeysMutation,
  useListAuthorizedEndpointsQuery,
  useLazyListAuthorizedEndpointsQuery,
  useUpdateStaffPermissionsMutation,
  useBulkUpsertStaffMutation,

  /* Pricing Region */
  useListPricingRegionsForCompanyQuery,
  useLazyListPricingRegionsForCompanyQuery,
  useUpdateCompanyIsPricingByRegionEnabledMutation,
  useCreatePricingRegionMutation,
  useUpdatePricingRegionNameMutation,
  useDeactivatePricingRegionMutation,
  useReorderPricingRegionsMutation,

  /* Pricing Tier */
  useListPricingTiersForCompanyQuery,
  useLazyListPricingTiersForCompanyQuery,
  useListCustomersForTierQuery,
  useCreatePricingTierMutation,
  useUpdatePricingTierMutation,
  useDeletePricingTierMutation,
  useReorderPricingTiersMutation,

  /* Financing Term */
  useListFinancingTermsForCompanyQuery,
  useLazyListFinancingTermsForCompanyQuery,
  useListCustomersForTermQuery,
  useCreateFinancingTermMutation,
  useUpdateFinancingTermMutation,
  useDeleteFinancingTermMutation,
  useReorderFinancingTermsMutation,

  /* Product Category V2 */
  useCreateProductCategoryV2Mutation,
  useUpdateProductCategoryV2Mutation,
  useDeactivateProductCategoryV2Mutation,
  useListProductCategoriesForCompanyV2Query,
  useListProductsForCategoryV2Query,
  useGetProductCategoryTreeQuery,
  useBulkUpsertDepartmentsMutation,
  useBulkUpsertClassesMutation,
  useBulkUpsertFinelinesMutation,

  /* Additional Fee */
  useListAdditionalFeesForCompanyQuery,
  useLazyListAdditionalFeesForCompanyQuery,
  useListProductsForFeeQuery,
  useCreateAdditionalFeeMutation,
  useUpdateAdditionalFeeMutation,
  useDeleteAdditionalFeeMutation,
  useReorderAdditionalFeesMutation,

  /* Tax Rate */
  useListTaxRatesForCompanyQuery,
  useLazyListTaxRatesForCompanyQuery,
  useCreateCustomTaxRateMutation,
  useUpdateCustomTaxRateMutation,
  useReorderCustomTaxRatesMutation,
  useDeactivateCustomTaxRateMutation,
  useListTaxRatesForLocationQuery,
  useGetOrCreateCustomTaxRateForAddressMutation,

  /* Roles */
  useGetPermissionsGroupsQuery,

  /* Finance Charge Setting */
  useCreateFinanceChargeSettingMutation,
  useUpdateFinanceChargeSettingMutation,
  useListActiveFinanceChargeSettingsForCompanyQuery,
  useListCustomersForFinanceChargeSettingQuery,
  useDeactivateFinanceChargeSettingMutation,
  useReorderFinanceChargeSettingsMutation,

  /* Address */
  useListStatesAndProvincesQuery,

  /* Sale Forms */
  useCreateSaleFormMutation,
  useUpdateSaleFormMutation,
  useListSaleFormsQuery,
  useDeleteSaleFormMutation,

  /* Entities */
  useListEntitiesForCompanyQuery,

  /* Drawer Methods */
  useListDrawerMethodsQuery,
  useCreateCustomTenderMethodMutation,
  useUpdateCustomTenderMethodMutation,
  useUpdateDefaultTenderMethodUsagesMutation,
  useDeactivateCustomTenderMethodMutation,
  useActivateCustomTenderMethodMutation,
  useReorderTenderMethodsMutation,
  useGetIsGiftCardsEnabledQuery,

  /* Units of Measure */
  useListUnitsOfMeasureForCompanyQuery,
  useAddCompanyUnitOfMeasureMutation,
  useUpdateCompanyUnitOfMeasureMutation,
  useDeleteCompanyUnitOfMeasureMutation,
  useBulkUpsertUnitsOfMeasureMutation,

  /* Banking */
  useGetIsBankingPermittedQuery,
  useLazyGetIsBankingPermittedQuery,

  /* Loyalty */
  useUpdateCompanyLoyaltyOptionsMutation,
  useUpdateCompanyLoyaltyRewardMutation,
  useListActiveLoyaltyRewardsForCompanyQuery,
} = companyApiSlice

function patchGetCompanyQueryData(patch: (company: Company) => void) {
  return companyApiSlice.util.updateQueryData(
    "getCompany",
    {},
    ({ company }) => {
      if (!company) {
        return
      }
      patch(company)
    }
  )
}

export function useGetActiveLocationCountQuery() {
  return useQuery({
    queryKey: ["active-location-count"],
    queryFn: async () => {
      const { response } = await c.getActiveLocationCount({})
      return response
    },
  })
}

export function useGetActiveStaffCountQuery() {
  return useQuery({
    queryKey: ["active-staff-count"],
    queryFn: async () => {
      const { response } = await c.getActiveStaffCount({})
      return response
    },
  })
}

export function useGetActiveTenderMethodCountQuery() {
  return useQuery({
    queryKey: ["active-tender-method-count"],
    queryFn: async () => {
      const { response } = await c.getActiveTenderMethodCount({})
      return response
    },
  })
}

export function useGetDefaultPaintCareFeesQuery() {
  return useQuery({
    queryKey: ["default-paint-care-fees"],
    queryFn: async () => {
      const { response } = await c.getDefaultPaintCareFees({})
      return response
    },
  })
}
